<template>
  <div>

    <b-modal
      v-for="avatar in data"
      :id="`${idm}-${avatar.titulo}-${avatar.id}`"
      :key="`a${avatar.titulo}-${avatar.id}`"
      scrollable
      size="lg"
      ok-only
      ok-title="Ok"
      button-size="sm"
    >
      <div class="rounded-top">
        <b-row align-v="center">
          <b-col>
            <div class="profile-image-wrapper">
              <div class="profile-image p-1 text-center">
                <b-avatar
                  size="170"
                  variant="light-secondary"
                  :alt="'Responsable de materia - Campus Virtual Indetec -' + avatar.picprofile"
                  :src="avatar.picprofile ? `${delivery}${avatar.picprofile}` : ''"
                />
              </div>
            </div>
          </b-col>
          <b-col>
            <h2>{{ avatar.titulo }}</h2>
            <small><b>{{ avatar.nplan }}</b></small>
            <br>
            <small>{{ avatar.subtitulo }}</small>
            <div class="text- mt-1">
              <b-img
                :style="'width: 40%'"
                :src="appLogoImage"
                alt="Indetec campus virtual"
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- eslint-disable vue/no-v-html -->
      <b-card-text
        class="m-3"
        v-html="avatar.descripcion"
      />
    </b-modal>

  </div>
</template>
<script>
import {
  BCol, BRow, BModal, BCardText, BImg,
  BAvatar,
} from 'bootstrap-vue'

import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BCol,
    BRow,
    BAvatar,
    BModal,
    BCardText,
    BImg,
  },
  props: {
    data: {
      type: [Array, null],
      default: null,
    },
    idm: {
      type: String,
      default: 'modal',
    },
  },
  setup() {
    const { appLogoImage } = $themeConfig.app
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    return {
      appLogoImage,
      delivery,
    }
  },
}
</script>
